import { NodeType } from 'Automations/nodeDefinitions/types'

export const getTaskReferenceName =
  <TaskName extends string>(nodeType: NodeType) =>
  (nodeId: string) =>
  (taskName: TaskName) => {
    return [nodeId, nodeType, taskName].join(':')
  }

/**
 * Conductor appends __0, __1 etc. to task reference names for loop
 * iterations — strip this suffix to recover the original node ID and
 * task name. The parsed iteration index lets callers pick the latest
 * iteration of a task inside a DO_WHILE loop.
 */
export const parseTaskReferenceName = (referenceName: string) => {
  const [rawNodeId, nodeType, rawTaskName] = referenceName.split(':')
  const nodeId = rawNodeId.replace(/__\d+$/, '')
  const taskName = rawTaskName?.replace(/__\d+$/, '')
  const iteration = Number(rawTaskName?.match(/__(\d+)$/)?.[1] ?? 0)
  return { nodeId, nodeType, taskName, iteration }
}
